import { LoadDoctorSurgeryRequestCount } from 'domain/usecases/doctor/load-doctor-surgery-request-count'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteDoctorLoadSurgeryRequestCount
  implements LoadDoctorSurgeryRequestCount
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  async count(): Promise<LoadDoctorSurgeryRequestCount.Model> {
    return await this.doctorRepository.countSurgeryRequests()
  }
  async countSchedulings(): Promise<LoadDoctorSurgeryRequestCount.Model> {
    return await this.doctorRepository.countSchedulingsSurgeryRequests()
  }
}

export type RemoteDoctorLoadSurgeryRequestCountModel =
  LoadDoctorSurgeryRequestCount.Model
